import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { performance } from '@ynap/clientside-monitoring';

const bem = new BEMHelper('ShopMore');

const ShopMore = (props) => {
    // TODO: Add designerSEO to polyjuice response - designer link is not working at the moment
    const { className, messages, product, locale, plpUrlTemplate, mappedCategories, generateListingUrl, linkOnClick = () => {}, ignoreCategories = [] } = props;

    // TODO: this should be merged into mappedCategories by product-details selectors
    let links = (product?.designerSeo && [{ label: product.designerName, url: product.designerSeo.seoURLKeyword }]) || [];
    mappedCategories?.forEach((category) => {
        if (!ignoreCategories?.includes(category.path)) {
            links.push({ label: category.label, url: category.path });
        }
    });

    return links.length > 0 ? (
        <div className={bem(null, null, className)}>
            <p className={bem('heading')}>{messages?.shopMore?.title()}</p>
            <div className={bem('links')}>
                {links.map((link, index) => (
                    <Fragment key={index}>
                        <Link
                            dir="ltr"
                            className={bem('link')}
                            to={generateListingUrl(plpUrlTemplate, {
                                LOCALE: locale,
                                SEO_URLKEYWORD: link.url,
                            })}
                            onClick={() => {
                                linkOnClick();
                                performance.intTiming.markSpaInteractionTime('pdp_to_plp');
                            }}
                        >
                            {link.label}
                        </Link>
                        {index + 1 < links.length && <div className={bem('arrow')} />}
                    </Fragment>
                ))}
            </div>
        </div>
    ) : (
        <div className={bem(null, null, className)} />
    );
};

ShopMore.propTypes = {
    className: PropTypes.string.isRequired,
    messages: PropTypes.shape({
        viewMore: PropTypes.shape({
            title: PropTypes.func.isRequired,
        }).isRequired,
    }),
    product: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    plpUrlTemplate: PropTypes.string.isRequired,
    mappedCategories: PropTypes.shape({
        seo: PropTypes.shape({ seoURLKeyword: PropTypes.string.isRequired }),
        child: PropTypes.object.isRequired,
    }),
    generateListingUrl: PropTypes.func.isRequired,
    linkOnClick: PropTypes.func,
    ignoreCategories: PropTypes.arrayOf(PropTypes.string),
};

export default ShopMore;
